import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

interface LoadingProps {
  noTheme?: boolean;
  height?: string;
  loadingText?: string;
}

export const Loading: React.FC<LoadingProps> = ({ noTheme, height = '20vh', loadingText = 'Aguarde, carregando...' }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height }}>
      <CircularProgress color="secondary" sx={{ color: noTheme && '#000814' }} />
      <Typography variant="body1" marginTop={2} color={noTheme ? '#000814' : 'secondary'}>
        {loadingText}
      </Typography>
    </Box>
  );
};
